enum HouseholdLimitTypeValue {
    None = 'None',
    Rewards = 'Rewards',
}

export default HouseholdLimitTypeValue;
